import type { RootState } from "infrastructure/store";
import { ApiState } from "infrastructure/api";
import { MenuItem } from "consts/shipmentTracking";

export const selectIsShipmentTrackingResourceUninitialized = (menuItem: MenuItem) =>
    (state: RootState) =>
        state.shipmentTracking[menuItem].tableLoadingState === ApiState.Idle;

export const selectIsShipmentTrackingResourceLoading = (menuItem: MenuItem) =>
    (state: RootState) =>
        state.shipmentTracking[menuItem].tableLoadingState === ApiState.Pending;

export const selectIsExportShipmentTrackingResourceLoading = (menuItem: MenuItem) =>
    (state: RootState) =>
        state.shipmentTracking[menuItem].exportLoadingState === ApiState.Pending;

export const selectShipmentTrackingResourceSlice = (menuItem: MenuItem) =>
    (state: RootState) =>
        state.shipmentTracking[menuItem].tableSlice;
